// @ts-nocheck
/**
 * Pincode Delivery & Installation Checker
 *
 * Flow (matches the product-page flowchart):
 *  1. If product has installation_available = false → no pincode gate, ATC free.
 *  2. If installation_available = true and no saved pincode → gate ATC.
 *  3. On Check:
 *     a. Look up delivery sheet:
 *        - Pincode not found  → show default TAT, allow ATC (proceed to install check)
 *        - Pincode = BLOCKED  → block ATC, show blocked message + CTA
 *        - Pincode found      → show TAT from sheet (proceed to install check)
 *     b. Look up installation sheet (SKU × Pincode):
 *        - Not serviceable    → show "not available" message, allow ATC without install add-on
 *        - Free installation  → mandatory locked checkbox, tooltip shown
 *        - Paid installation  → optional active toggle, price shown
 *  4. On ATC with install checkbox checked → add both products via Cart API.
 *  5. Pincode saved to localStorage on success; auto-checked on return visit.
 *
 *  Debug: open DevTools → Console, filter by [Qubo pincode]
 *  Silence: window.__QUBO_PINCODE_DEBUG = false
 */
(function () {
  'use strict';

  var CUT_OFF_HOUR = 17;
  var LS_KEY = 'qubo_delivery_pincode';
  var BLOCKED_SENTINEL = 'BLOCKED';
  var SHEET_CACHE_TTL_MS = 5 * 60 * 1000;

  /** Debug: set window.__QUBO_PINCODE_DEBUG = false to silence logs */
  function quboLog() {
    if (window.__QUBO_PINCODE_DEBUG === false) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Qubo pincode]');
    console.log.apply(console, args);
  }

  /* ── helpers ───────────────────────────────────────────────────── */

  function parseConfig(root) {
    var el = root.querySelector('[data-delivery-checker-config]');
    if (!el || !el.textContent) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function readSheetCache(url) {
    try {
      var key = 'qubo_sheet_cache_' + url;
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !parsed.data) return null;
      if (Date.now() - parsed.ts > SHEET_CACHE_TTL_MS) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeSheetCache(url, data) {
    try {
      var key = 'qubo_sheet_cache_' + url;
      localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) {}
  }

  function fetchSheetJson(url) {
    var cached = readSheetCache(url);
    if (cached) return Promise.resolve(cached);
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Network');
        return res.json();
      })
      .then(function (data) {
        writeSheetCache(url, data);
        return data;
      });
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    // Treat sheet TAT values as calendar days (weekends included).
    d.setDate(d.getDate() + n);
    return d;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  }

  function formatDateRange(fromDate, toDate) {
    var fromText = formatDate(fromDate);
    var toText = formatDate(toDate);
    if (fromText === toText) return fromText;
    return fromText + ' - ' + toText;
  }

  function normalizeYesNo(value) {
    var v = String(value || '').trim().toUpperCase();
    if (v === 'YES' || v === 'Y' || v === 'TRUE' || v === '1') return 'YES';
    if (v === 'NO' || v === 'N' || v === 'FALSE' || v === '0') return 'NO';
    return '';
  }

  function resolveProductCategory(config) {
    var parts = [];
    var productType = String(config.productType || '').toLowerCase();
    var productHandle = String(config.productHandle || '').toLowerCase();
    var productSku = String(config.productSku || '').toLowerCase();
    var tags = Array.isArray(config.productTags) ? config.productTags.map(function (t) { return String(t || '').toLowerCase(); }) : [];

    parts.push(productType);
    parts.push(productHandle);
    parts.push(productSku);
    parts = parts.concat(tags);
    var hay = parts.join(' ');

    // Priority matters: Smart Lock PDPs can carry unrelated tags, but must always use Lock column.
    if (
      productType.indexOf('lock') > -1 ||
      productHandle.indexOf('smart-lock') > -1 ||
      productHandle.indexOf('door-lock') > -1 ||
      productHandle.indexOf('lock') > -1 ||
      tags.some(function (t) { return t.indexOf('lock') > -1 || t.indexOf('smart-lock') > -1 || t.indexOf('door-lock') > -1; })
    ) return 'lock';

    if (hay.indexOf('video door') > -1 || hay.indexOf('doorbell') > -1 || hay.indexOf(' vdb ') > -1 || hay.indexOf('vdb') > -1) return 'vdb';
    if (hay.indexOf('tracker') > -1 || hay.indexOf('gps') > -1) return 'tracker';
    if (hay.indexOf('dashcam') > -1) return 'dashcam';
    if (hay.indexOf('camera') > -1 || hay.indexOf(' cam ') > -1) return 'camera';

    return '';
  }

  function openConsultationPopup() {
    if (typeof window.openConsultationPopup === 'function' && window.openConsultationPopup !== openConsultationPopup) {
      window.openConsultationPopup();
      return true;
    }
    var openerKey = Object.keys(window).find(function (key) {
      return key.indexOf('openConsultationPopup_') === 0 && typeof window[key] === 'function';
    });
    if (openerKey && typeof window[openerKey] === 'function') {
      window[openerKey]();
      return true;
    }
    var popup =
      document.querySelector('.consultation-popup') ||
      document.getElementById('callbackbopup') ||
      document.querySelector('[id*="consultation-popup"]');
    if (popup) {
      var popupBody = popup.querySelector('.popup-body');
      var headerTitle = popup.querySelector('.popup-header-title');
      var headerSubtitle = popup.querySelector('.popup-slogon');
      var mainCloseBtn = popup.querySelector('.popup-close');
      var successMsg = popup.querySelector('.success-message');
      if (popupBody) popupBody.style.display = '';
      if (headerTitle) headerTitle.style.display = '';
      if (headerSubtitle) headerSubtitle.style.display = '';
      if (mainCloseBtn) mainCloseBtn.style.display = '';
      if (successMsg) successMsg.classList.add('hidden');
      popup.classList.remove('hidden');
      popup.style.display = 'flex';
      popup.style.opacity = '1';
      popup.style.visibility = 'visible';
      document.body.style.overflow = 'hidden';
      return true;
    }
    var pageConsultBtn =
      document.querySelector('.hassel-book-free-btn') ||
      document.querySelector('[onclick*="callbackbopup"]') ||
      document.querySelector('[onclick*="openConsultationPopup"]');
    if (pageConsultBtn && typeof pageConsultBtn.click === 'function') {
      pageConsultBtn.click();
      return true;
    }
    var fallbackTrigger = document.querySelector('[onclick*="openConsultationPopup"]');
    if (fallbackTrigger && typeof fallbackTrigger.click === 'function') {
      fallbackTrigger.click();
      return true;
    }
    return false;
  }
  if (typeof window.openConsultationPopup !== 'function') {
    window.openConsultationPopup = openConsultationPopup;
  }

  function isZeroMoneyText(text) {
    var t = String(text || '').toLowerCase().replace(/[\s,]/g, '');
    return t.indexOf('₹0') > -1 || t.indexOf('rs.0') > -1 || t.indexOf('rs0') > -1 || t.indexOf('0.00') > -1;
  }

  function isInstallFree(config) {
    if (!config) return false;
    if (config.freeInstallation === true) return true;
    if (config.installProduct && config.installProduct.freeInstallation === true) return true;
    var line = (config.installProduct && config.installProduct.priceLine) || config.installPriceLine || '';
    return isZeroMoneyText(line);
  }

  function findRowByPincode(rows, pinIdx, pincode) {
    return rows.find(function (r) {
      return r && String(r[pinIdx] || '').trim() === pincode;
    });
  }

  function setCheckButtonState(btn, enabled, loading, loadingLabel) {
    if (!btn) return;
    btn.disabled = !enabled || loading;
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      btn.dataset.labelDefault = btn.dataset.labelDefault || btn.textContent.trim();
      btn.textContent = loadingLabel || btn.dataset.labelLoading || '…';
    } else if (btn.dataset.labelDefault) {
      btn.textContent = btn.dataset.labelDefault;
    }
  }

  function hideAllMessages(root) {
    var keys = ['loading', 'error', 'success', 'notServiceable', 'invalid', 'blocked', 'consultationRequired', 'pincodeRequired'];
    keys.forEach(function (key) {
      var el = root.querySelector('[data-msg="' + key + '"]');
      if (!el) return;
      el.hidden = true;
      el.setAttribute('hidden', '');
      if (key === 'pincodeRequired') {
        el.style.display = '';
        el.removeAttribute('role');
        el.removeAttribute('aria-live');
      }
    });
    var installBox = root.querySelector('[data-installation-product]');
    if (installBox) installBox.hidden = true;
    var installNot = root.querySelector('[data-install-not-serviceable]');
    if (installNot) installNot.hidden = true;
  }

  function showMsg(root, key) {
    var el = root.querySelector('[data-msg="' + key + '"]');
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
    if (key === 'pincodeRequired') {
      el.style.display = 'block';
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'polite');
    }
  }

  /* ── ATC button utilities ──────────────────────────────────────── */

  function findAtcButtons(productId) {
    var found = [];
    var seen = new Set();
    function pushBtn(btn) {
      if (!btn || seen.has(btn)) return;
      seen.add(btn);
      found.push(btn);
    }
    document.querySelectorAll('button[type="submit"][name="add"]').forEach(function (b) {
      pushBtn(b);
    });
    var sticky = document.querySelector('sticky-add-to-cart[data-product-id="' + productId + '"]');
    if (sticky) {
      sticky.querySelectorAll('.add-to-cart-button').forEach(function (b) { pushBtn(b); });
    }
    return found;
  }

  function captureOriginalAtcState(productId) {
    findAtcButtons(productId).forEach(function (btn) {
      if (btn.dataset.quboOriginalDisabled != null) return;
      btn.dataset.quboOriginalDisabled = btn.disabled ? 'true' : 'false';
    });
  }

  function shouldKeepAtcDisabled(btn) {
    if (btn.dataset.quboOriginalDisabled === 'true') return true;
    var atcComponent = btn.closest('add-to-cart-component');
    if (atcComponent && atcComponent.classList.contains('sold_out_product')) return true;
    return false;
  }

  function restoreAtcButton(btn) {
    btn.removeAttribute('data-qubo-pincode-blocked');
    btn.removeAttribute('data-qubo-consultation-disabled');
    btn.style.display = '';

    if (shouldKeepAtcDisabled(btn)) {
      btn.disabled = true;
      return;
    }

    btn.disabled = false;
    btn.removeAttribute('disabled');
    if (!btn.classList.contains('disabled')) {
      btn.removeAttribute('aria-disabled');
    }

    var atcComponent = btn.closest('add-to-cart-component');
    if (atcComponent && typeof atcComponent.enable === 'function') {
      atcComponent.enable();
    }
  }

  function unblockAtcButtons(productId) {
    findAtcButtons(productId).forEach(restoreAtcButton);
  }

  function blockAtcButtons(productId) {
    findAtcButtons(productId).forEach(function (btn) {
      btn.setAttribute('data-qubo-pincode-blocked', 'true');
      btn.disabled = true;
    });
  }

  /* ── installation UI ───────────────────────────────────────────── */

  function setInstallPriceDisplay(priceEl, config, freeInstall) {
    if (!priceEl) return;
    var ip = config.installProduct || {};
    var saleLine = ip.priceLine || config.installPriceLine || '';
    var compareLine = ip.compareAtPriceLine || '';
    var compareAt = Number(ip.compareAtPrice) || 0;
    var price = Number(ip.price) || 0;
    var hasCompare = compareLine && (freeInstall ? compareAt > 0 : compareAt > price);

    if (freeInstall) {
      if (hasCompare) {
        priceEl.innerHTML =
          '<s class="product-delivery-checker__install-compare-at">' +
          compareLine +
          '</s> <span>Free</span>';
      } else {
        priceEl.textContent = 'Free';
      }
      return;
    }
    if (hasCompare) {
      priceEl.innerHTML =
        '<s class="product-delivery-checker__install-compare-at">' +
        compareLine +
        '</s> <span>' +
        saleLine +
        '</span>';
    } else {
      priceEl.textContent = saleLine;
    }
  }

  function showInstallServiceable(root, config) {
    var box = root.querySelector('[data-installation-product]');
    var notBox = root.querySelector('[data-install-not-serviceable]');
    if (notBox) notBox.hidden = true;
    if (!box) return;
    if (!config.installProduct || !config.installProduct.title) return;

    var img = box.querySelector('[data-install-img]');
    var titleEl = box.querySelector('[data-install-title]');
    var priceEl = box.querySelector('[data-install-price]');
    var cb = box.querySelector('[data-install-checkbox]');

    if (img) {
      if (config.installProduct.image && img.tagName === 'IMG') {
        img.src = config.installProduct.image;
        img.alt = config.installProduct.title;
        img.hidden = false;
        img.removeAttribute('hidden');
      } else {
        img.hidden = true;
      }
    }
    if (titleEl) titleEl.textContent = config.installProduct.title;
    var freeInstall = isInstallFree(config);
    setInstallPriceDisplay(priceEl, config, freeInstall);
    if (cb) {
      cb.checked = true;
      cb.value = String(config.installProduct.variantId || '');
      if (freeInstall) {
        cb.disabled = true;
        cb.setAttribute('aria-disabled', 'true');
      } else {
        cb.disabled = false;
        cb.removeAttribute('aria-disabled');
      }
    }

    box.hidden = false;
    box.removeAttribute('hidden');
  }

  function showInstallNotServiceable(root) {
    var box = root.querySelector('[data-installation-product]');
    var notBox = root.querySelector('[data-install-not-serviceable]');
    var cb = root.querySelector('[data-install-checkbox]');
    if (cb && cb instanceof HTMLInputElement) {
      cb.checked = false;
      cb.disabled = true;
      cb.setAttribute('aria-disabled', 'true');
    }
    if (box) box.hidden = true;
    if (notBox) { notBox.hidden = false; notBox.removeAttribute('hidden'); }
  }

  /* ── installation sheet lookup ─────────────────────────────────── */

  /**
   * @param {() => boolean} [isStale] — if true, skip callbacks (pincode/check superseded)
   */
  function lookupInstallSheet(installSheetUrl, pincode, sku, handle, categoryKey, onServiceable, onNotServiceable, isStale) {
    if (!installSheetUrl) {
      quboLog('install sheet URL missing — skipping install matrix check');
      if (!isStale || !isStale()) onServiceable();
      return;
    }
    quboLog('fetching install sheet:', installSheetUrl, '| pincode:', pincode, '| category:', categoryKey || '(unknown)');
    fetchSheetJson(installSheetUrl)
      .then(function (data) {
        if (isStale && isStale()) return;
        var values = data && data.values;
        if (!values || !Array.isArray(values)) throw new Error('Bad data');
        var rows = values.slice(1);

        var header = values[0] || [];
        var headerLc = header.map(function (h) { return String(h || '').trim().toLowerCase(); });
        var pinIdx = headerLc.findIndex(function (h) {
          return h === 'pincode' || h === 'pin code' || h === 'serviceable pincodes';
        });

        // New matrix format: PinCode + category YES/NO columns.
        if (pinIdx > -1) {
          var categoryHeaderMap = {
            tracker: 'tracker',
            vdb: 'vdb',
            camera: 'camera',
            dashcam: 'dashcam',
            lock: 'lock'
          };
          var wantedHeader = categoryHeaderMap[categoryKey] || '';
          var categoryIdx = wantedHeader ? headerLc.findIndex(function (h) { return h === wantedHeader; }) : -1;
          if (categoryIdx === -1) {
            if (!isStale || !isStale()) onServiceable();
            return;
          }
          var pinRow = findRowByPincode(rows, pinIdx, pincode);
          if (!pinRow) {
            quboLog('install matrix row not found for pincode:', pincode);
            if (!isStale || !isStale()) onNotServiceable();
            return;
          }

          var yn = normalizeYesNo(pinRow[categoryIdx]);
          quboLog('install matrix value', wantedHeader + ':', yn || '(blank)', '| pin:', pincode);
          if (yn === 'NO') {
            if (!isStale || !isStale()) onNotServiceable();
            return;
          }
          if (!isStale || !isStale()) onServiceable();
          return;
        }

        // Legacy fallback format: Col A = SKU/handle, Col B = Pincode, Col C = type
        // Use a single .find() scan; prefer exact SKU/handle+pin, fall back to pin-only row if needed.
        var wantedSku = String(sku || '').trim().toLowerCase();
        var wantedHandle = String(handle || '').trim().toLowerCase();
        var pinOnlyCandidate = null;
        var match = rows.find(function (r) {
          if (!r) return false;
          var colA = String(r[0] || '').trim().toLowerCase();
          var colB = String(r[1] || '').trim();
          if (colB === pincode && (colA === wantedSku || colA === wantedHandle)) return true;
          if (!pinOnlyCandidate && String(r[0] || '').trim() === pincode) pinOnlyCandidate = r;
          return false;
        });
        if (!match) match = pinOnlyCandidate;
        if (!match) {
          if (!isStale || !isStale()) onNotServiceable();
          return;
        }
        var typeVal = String(match[2] || match[1] || '').trim().toLowerCase();
        if (typeVal === 'no' || typeVal === 'n' || typeVal === 'false' || typeVal === '0') {
          if (!isStale || !isStale()) onNotServiceable();
          return;
        }
        if (!isStale || !isStale()) onServiceable(typeVal);
      })
      .catch(function () {
        if (isStale && isStale()) return;
        // On fetch error, fall back to showing install UI (fail open for install)
        onServiceable();
      });
  }

  /* ── success UI ────────────────────────────────────────────────── */

  function renderSuccess(root, config, deliveryLine) {
    var line1 = root.querySelector('[data-success-line1]');
    var line2 = root.querySelector('[data-success-line2]');

    if (line1) {
      var installHint = '';
      if (config.installationAvailable) {
        installHint = isInstallFree(config)
          ? ' | Free installation'
          : ' | Installation @ ' + (config.installPriceLine || '₹699');
      }
      line1.textContent = deliveryLine + installHint;
    }

    if (line2) {
      if (config.installationAvailable) {
        line2.textContent = 'Installation service check in progress…';
        line2.hidden = false;
        line2.removeAttribute('hidden');
      } else {
        line2.hidden = true;
      }
    }

    showMsg(root, 'success');
  }

  function updateSuccessLine2(root, text) {
    var line2 = root.querySelector('[data-success-line2]');
    if (!line2) return;
    if (text) {
      line2.textContent = text;
      line2.hidden = false;
      line2.removeAttribute('hidden');
    } else {
      line2.hidden = true;
    }
  }

  function updateSuccessLine1(root, text) {
    var line1 = root.querySelector('[data-success-line1]');
    if (!line1) return;
    line1.textContent = text || '';
  }

  /* ── main init per root ────────────────────────────────────────── */

  function initRoot(root) {
    if (!root || root.dataset.quboPdcInit === '1') return;
    root.dataset.quboPdcInit = '1';

    var config = parseConfig(root);
    if (!config || !config.sheetUrl) {
      quboLog('init skipped — missing config or sheetUrl (delivery checker inactive)');
      return;
    }

    var productId = root.getAttribute('data-product-id') || '';
    var productCategory = resolveProductCategory(config);
    var input = root.querySelector('[data-pincode-input]');
    var checkBtn = root.querySelector('[data-check-button]');
    var state = {
      rows: null,
      sheetError: false,
      pincodeChecked: false,    // true after a successful (non-blocked) check
      pincodeBlocked: false,    // true if current checked pincode is BLOCKED
      consultationRequired: false, // true when pincode is not serviceable in delivery sheet
      installServiceable: null, // null=unknown, true, false
      /** bumped when pincode/check is invalidated — stale async UI updates are skipped */
      validationSeq: 0
    };

    /* ── lock free-install checkbox ── */
    var installCb = root.querySelector('[data-install-checkbox]');
    if (installCb && config.freeInstallation === true) {
      installCb.checked = true;
      installCb.disabled = true;
      installCb.setAttribute('aria-disabled', 'true');
      installCb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); installCb.checked = true; });
      installCb.addEventListener('change', function () { installCb.checked = true; });
    }

    /* ── pre-fill pincode from localStorage ── */
    var savedPincode = localStorage.getItem(LS_KEY);
    if (savedPincode && input) {
      input.value = savedPincode;
    }

    function normalizedPinFromInput() {
      return input ? String(input.value || '').replace(/\D/g, '') : '';
    }

    /** True only when Check has succeeded for the pincode currently in the field (matches LS). */
    function isAtcAllowed() {
      if (state.pincodeBlocked || state.consultationRequired) return false;
      var raw = normalizedPinFromInput();
      var ls = localStorage.getItem(LS_KEY);
      return state.pincodeChecked === true && raw.length === 6 && ls === raw;
    }

    /**
     * product-form handleSubmit uses document/capture (see @theme/component) and runs *before*
     * our form submit listener — product-form.js reads this to block cart/add.
     */
    function publishGateState() {
      window.__quboPincodeGate = window.__quboPincodeGate || {};
      window.__quboPincodeGate[String(productId)] = {
        checked: state.pincodeChecked,
        blocked: state.pincodeBlocked || state.consultationRequired,
        installServiceable: state.installServiceable
      };
    }
    captureOriginalAtcState(productId);
    publishGateState();
    setAtcButtonsConsultationMode(false);

    function getOrCreateConsultationButton(originalBtn) {
      if (!originalBtn.dataset.quboConsultRef) {
        originalBtn.dataset.quboConsultRef = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 8);
      }
      var consultBtn = originalBtn.parentElement
        ? originalBtn.parentElement.querySelector('[data-qubo-consultation-btn-for="' + originalBtn.dataset.quboConsultRef + '"]')
        : null;
      if (consultBtn) return consultBtn;

      consultBtn = document.createElement('button');
      consultBtn.type = 'button';
      consultBtn.className = originalBtn.className || '';
      consultBtn.setAttribute('data-qubo-consultation-btn', 'true');
      consultBtn.setAttribute('data-qubo-consultation-btn-for', originalBtn.dataset.quboConsultRef);
      consultBtn.setAttribute('data-qubo-product-id', String(productId));
      consultBtn.textContent = 'BOOK FREE CONSULTATION';
      consultBtn.style.display = 'none';
      consultBtn.addEventListener('click', function (e) {
        document.querySelector('.book-installment').click();
        e.preventDefault();
        e.stopImmediatePropagation();
        triggerConsultationPrompt();

      });

      originalBtn.insertAdjacentElement('afterend', consultBtn);
      return consultBtn;
    }

    function cleanupConsultationButtons(activeRefs, enabled) {
      document.querySelectorAll('[data-qubo-consultation-btn="true"]').forEach(function (btn) {
        if (!(btn instanceof HTMLElement)) return;
        if (btn.getAttribute('data-qubo-product-id') !== String(productId)) return;
        var ref = btn.getAttribute('data-qubo-consultation-btn-for') || '';
        if (!activeRefs.has(ref)) {
          btn.remove();
          return;
        }
        if (!enabled) {
          btn.style.display = 'none';
          btn.disabled = true;
        }
      });
    }

    function setAtcButtonsConsultationMode(enabled) {
      var activeRefs = new Set();
      findAtcButtons(productId).forEach(function (btn) {
        if (!(btn instanceof HTMLElement)) return;
        if (btn.dataset.quboConsultRef) activeRefs.add(btn.dataset.quboConsultRef);
        var consultBtn = getOrCreateConsultationButton(btn);
        if (!(consultBtn instanceof HTMLElement)) return;
        activeRefs.add(btn.dataset.quboConsultRef || '');

        if (enabled) {
          btn.setAttribute('data-qubo-consultation-disabled', 'true');
          btn.style.display = 'none';
          btn.disabled = true;
          consultBtn.style.display = '';
          consultBtn.disabled = false;
          return;
        }

        restoreAtcButton(btn);
        consultBtn.style.display = 'none';
      });
      cleanupConsultationButtons(activeRefs, enabled);
    }

    /** ATC / submit blocked — show prompt and cancel any pending install-sheet callbacks */
    function triggerPincodePrompt() {
      state.validationSeq++;
      quboLog('triggerPincodePrompt — showing inline message below pincode');
      hideAllMessages(root);
      showMsg(root, 'pincodeRequired');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (input) {
        setTimeout(function () {
          input.setAttribute('data-highlight', '');
          input.focus();
          setTimeout(function () { input.removeAttribute('data-highlight'); }, 1600);
        }, 400);
      }
    }

    function triggerConsultationPrompt() {
      hideAllMessages(root);
      showMsg(root, 'consultationRequired');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      console.log('triggerConsultationPrompt');
      document.querySelector('.book-installment').click();
    }

    /**
     * Overlay approach — the only reliable way to intercept ATC before the
     * theme's own click/submit handlers, which are registered during
     * connectedCallback (before DOMContentLoaded) and therefore always fire
     * first if we use the same element + same phase.
     *
     * Strategy: inject a transparent <span> as a SIBLING of the ATC button
     * inside its parent container. The button is then NOT in the click event's
     * ancestor chain, so none of the button's own capture/bubble listeners
     * fire when the overlay is clicked.
     */

    var OVERLAY_ATTR = 'data-qubo-atc-overlay';

    function makeOverlay(onClickCb) {
      var el = document.createElement('span');
      el.setAttribute(OVERLAY_ATTR, '');
      el.setAttribute('aria-hidden', 'true');
      el.style.cssText = [
        'position:absolute',
        'top:0', 'left:0', 'right:0', 'bottom:0',
        'z-index:9999',
        'cursor:pointer',
        'display:block',
        'border-radius:inherit'
      ].join(';');
      el.addEventListener('click', onClickCb);
      return el;
    }

    function ensurePositioned(el) {
      if (window.getComputedStyle(el).position === 'static') {
        el.style.position = 'relative';
        el.setAttribute('data-qubo-positioned', '');
      }
    }

    function addOverlays() {
      var comps = document.querySelectorAll('add-to-cart-component');
      var addedMain = 0;
      var skippedHadOverlay = 0;
      var skippedNoBtn = 0;
      // ── Main product ATC buttons (inside add-to-cart-component) ──
      comps.forEach(function (comp) {
        if (comp.querySelector('[' + OVERLAY_ATTR + ']')) {
          skippedHadOverlay++;
          return;
        }
        if (!comp.querySelector('button[name="add"]')) {
          skippedNoBtn++;
          return;
        }
        ensurePositioned(comp);
        comp.appendChild(makeOverlay(function (e) {
          e.stopPropagation();
          if (state.consultationRequired) {
            quboLog('overlay click (main ATC) — consultation required');
            triggerConsultationPrompt();
            return;
          }
          quboLog('overlay click (main ATC) — blocking cart, showing pincode prompt');
          triggerPincodePrompt();
        }));
        addedMain++;
      });

      // ── Sticky bar ATC button ──
      var stickyBtn = document.querySelector(
        'sticky-add-to-cart[data-product-id="' + productId + '"] .add-to-cart-button'
      );
      var stickyAdded = false;
      if (stickyBtn && !stickyBtn.querySelector('[' + OVERLAY_ATTR + ']')) {
        ensurePositioned(stickyBtn);
        stickyBtn.appendChild(makeOverlay(function (e) {
          e.stopPropagation();
          if (state.consultationRequired) {
            quboLog('overlay click (sticky ATC) — consultation required');
            triggerConsultationPrompt();
            return;
          }
          quboLog('overlay click (sticky ATC) — blocking cart, showing pincode prompt');
          triggerPincodePrompt();
        }));
        stickyAdded = true;
      }
      quboLog(
        'addOverlays — productId:',
        productId,
        '| add-to-cart-component count:',
        comps.length,
        '| overlays added:',
        addedMain + (stickyAdded ? 1 : 0),
        '| skipped (already had overlay):',
        skippedHadOverlay,
        '| skipped (no button[name=add]):',
        skippedNoBtn,
        '| sticky overlay:',
        stickyAdded ? 'yes' : 'no'
      );
    }

    var overlaySyncQueued = false;
    var consultSyncQueued = false;
    function scheduleAddOverlays() {
      if (overlaySyncQueued) return;
      overlaySyncQueued = true;
      var schedule = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
      schedule(function () {
        overlaySyncQueued = false;
        if (config.installationAvailable && !isAtcAllowed()) addOverlays();
      });
    }

    function scheduleConsultationMode(enabled) {
      if (consultSyncQueued) return;
      consultSyncQueued = true;
      var schedule = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
      schedule(function () {
        consultSyncQueued = false;
        setAtcButtonsConsultationMode(enabled);
      });
    }

    function removeOverlays() {
      var n = document.querySelectorAll('[' + OVERLAY_ATTR + ']').length;
      if (n) quboLog('removeOverlays — removing', n, 'overlay(s); ATC no longer gated');
      document.querySelectorAll('[' + OVERLAY_ATTR + ']').forEach(function (el) {
        el.remove();
      });
      document.querySelectorAll('[data-qubo-positioned]').forEach(function (el) {
        el.style.position = '';
        el.removeAttribute('data-qubo-positioned');
      });
    }

    window.__quboPincodePromptByProduct = window.__quboPincodePromptByProduct || {};
    window.__quboPincodePromptByProduct[String(productId)] = function () {
      addOverlays();
      if (state.consultationRequired) {
        triggerConsultationPrompt();
      } else {
        triggerPincodePrompt();
      }
    };

    quboLog(
      'init — productId:',
      productId,
      '| sheetUrl:',
      !!config.sheetUrl,
      '| localStorage pincode:',
      savedPincode ? '"' + savedPincode + '"' : '(none)',
      '| input value:',
      input ? '"' + (input.value || '').trim() + '"' : '(no input)'
    );
    if (savedPincode) {
      quboLog(
        'hint: localStorage has a saved pincode — if the field looks empty, clear LS or edit the field to re-gate ATC:',
        'localStorage.removeItem("' + LS_KEY + '")'
      );
    }
    quboLog('resolved category for install matrix:', productCategory || '(unknown)');

    // Gate ATC only when installation flow applies (see flowchart: installation metafield true)
    if (config.installationAvailable && !isAtcAllowed()) {
      addOverlays();
    } else if (!config.installationAvailable) {
      quboLog('init — installation unavailable for product; pincode ATC overlays skipped');
    } else {
      quboLog('init — pincode already valid for current input; overlays skipped');
    }

    // Re-check after DOM changes (variant switches, quick-add modals, etc.)
    var overlayObserver = new MutationObserver(function (mutations) {
      var shouldSyncOverlay = false;
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (!mutation || !mutation.addedNodes) continue;
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (
            (node.matches && (
              node.matches('add-to-cart-component') ||
              node.matches('sticky-add-to-cart') ||
              node.matches('button[name="add"]') ||
              node.matches('.add-to-cart-button')
            )) ||
            (node.querySelector && node.querySelector(
              'add-to-cart-component, sticky-add-to-cart, button[name="add"], .add-to-cart-button'
            ))
          ) {
            shouldSyncOverlay = true;
            break;
          }
        }
        if (shouldSyncOverlay) break;
      }
      if (shouldSyncOverlay) {
        if (state.consultationRequired) scheduleConsultationMode(true);
        scheduleAddOverlays();
      }
    });
    overlayObserver.observe(document.body, { childList: true, subtree: true });

    /**
     * Capture-phase submit handler:
     * Always block add-to-cart if pincode field does not match a completed Check.
     *
     * Important: actual cart submission (including installation add-on line item)
     * is handled by assets/product-form.js. Do not perform cart/add here or it can
     * double-submit the same product.
     */
    function attachFormSubmitGate(form) {
      if (!form || form.__quboFormSubmitGate) return;
      form.__quboFormSubmitGate = true;
      form.addEventListener('submit', function (e) {
        if (!config.installationAvailable) return;

        if (state.consultationRequired) {
          e.preventDefault();
          e.stopImmediatePropagation();
          quboLog('submit blocked — consultation required for current pincode');
          addOverlays();
          triggerConsultationPrompt();
          return;
        }

        if (state.pincodeBlocked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          quboLog('submit blocked — delivery BLOCKED for this pincode');
          return;
        }

        if (!isAtcAllowed()) {
          quboLog('submit blocked — pincode missing or not checked', {
            raw: normalizedPinFromInput(),
            ls: localStorage.getItem(LS_KEY),
            pincodeChecked: state.pincodeChecked
          });
          e.preventDefault();
          e.stopImmediatePropagation();
          addOverlays();
          triggerPincodePrompt();
          return;
        }

        // Let product-form.js handle normal submit from here.
      }, true);
    }

    document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(attachFormSubmitGate);

    // Ensure BOOK FREE CONSULTATION state is clickable even if theme ATC handlers differ.
    document.addEventListener('click', function (e) {
      if (!state.consultationRequired) return;
      var atcBtn = e.target.closest('button[name="add"], .add-to-cart-button');
      if (!atcBtn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addOverlays();
      triggerConsultationPrompt();
    }, true);

    var formGateObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-type="add-to-cart-form"]')) attachFormSubmitGate(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-type="add-to-cart-form"]').forEach(attachFormSubmitGate);
          }
        });
      });
    });
    formGateObserver.observe(document.body, { childList: true, subtree: true });

    /* ── check handler ── */
    function runCheck() {
      if (!input || !checkBtn) return;
      var seq = ++state.validationSeq;
      var raw = input.value.replace(/\D/g, '');
      hideAllMessages(root);
      state.consultationRequired = false;
      setAtcButtonsConsultationMode(false);

      if (raw.length !== 6) { showMsg(root, 'invalid'); return; }
      if (state.sheetError) { showMsg(root, 'error'); return; }
      if (!state.rows || !state.rows.length) { showMsg(root, 'error'); return; }

      // Find pincode row in delivery sheet (Col A = pincode)
      var row = state.rows.find(function (ele) {
        return String(ele && ele[0] || '').trim() === raw;
      });
      quboLog('delivery lookup — input pincode:', raw, '| matched row:', row || '(not found)');

      // BLOCKED?
      if (row) {
        var tatRaw = String(row[1] || '').trim();
        var fromDateRaw = String(row[1] || '').trim();
        var toDateRaw = String(row[2] || row[1] || '').trim();
        quboLog('delivery row values — fromDate(col B):', fromDateRaw, '| toDate(col C):', toDateRaw);
        if (tatRaw.toUpperCase() === BLOCKED_SENTINEL) {
          state.pincodeChecked = false;
          state.pincodeBlocked = true;
          state.consultationRequired = false;
          state.installServiceable = false;
          localStorage.removeItem(LS_KEY);
          blockAtcButtons(productId);
          addOverlays(); // keep overlay while blocked so BLOCKED buttons stay dead
          publishGateState();
          setAtcButtonsConsultationMode(false);
          showMsg(root, 'blocked');
          return;
        }
      }

      // Pincode not mapped in delivery sheet -> consultation flow
      if (!row) {
        state.pincodeBlocked = false;
        state.pincodeChecked = false;
        state.consultationRequired = true;
        state.installServiceable = false;
        localStorage.removeItem(LS_KEY);
        // Keep button enabled so user can click CTA and open consultation popup.
        unblockAtcButtons(productId);
        addOverlays();
        publishGateState();
        setAtcButtonsConsultationMode(true);
        showMsg(root, 'consultationRequired');
        updateSuccessLine2(root, '');
        quboLog('runCheck result — pincode not in delivery sheet; consultation mode enabled');
        return;
      }

      // Valid mapped pincode
      state.pincodeBlocked = false;
      state.consultationRequired = false;
      state.pincodeChecked = true;
      state.installServiceable = null;
      localStorage.setItem(LS_KEY, raw);
      unblockAtcButtons(productId);
      publishGateState();
      setAtcButtonsConsultationMode(false);
      quboLog('runCheck OK — pincode validated:', raw, '| removing ATC overlays');
      removeOverlays(); // pincode valid — let ATC work normally

      // Build delivery line from range (Sheet1: From Date / To Date)
      var deliveryLine;
      var fromDays = parseInt(String(row[1] || ''), 10);
      var toDays = parseInt(String(row[2] || row[1] || ''), 10);
      quboLog('delivery parse — fromDays:', fromDays, '| toDays:', toDays, '| raw row:', row);
      if (isNaN(fromDays) || fromDays < 0 || isNaN(toDays) || toDays < 0) {
        deliveryLine = 'Delivery in ' + (config.defaultTatText || '5-8 business days');
        quboLog('delivery parse fallback used — invalid from/to day values for pincode:', raw);
      } else {
        if (toDays < fromDays) {
          var tmp = fromDays;
          fromDays = toDays;
          toDays = tmp;
        }
        var extra = (new Date()).getHours() >= CUT_OFF_HOUR ? 1 : 0;
        var arrivalFrom = addBusinessDays(new Date(), fromDays + extra);
        var arrivalTo = addBusinessDays(new Date(), toDays + extra);
        deliveryLine = 'Arrives between ' + formatDateRange(arrivalFrom, arrivalTo);
      }

      renderSuccess(root, config, deliveryLine);

      // Now check installation serviceability
      if (!config.installationAvailable || !config.installProduct) {
        state.installServiceable = null;
        publishGateState();
        updateSuccessLine2(root, '');
        return;
      }

      lookupInstallSheet(
        config.installSheetUrl || '',
        raw,
        config.productSku || '',
        config.productHandle || '',
        productCategory,
        function (installType) {
          if (seq !== state.validationSeq) return;
          // Serviceable — override free/paid from sheet if type was returned
          state.installServiceable = true;
          publishGateState();
          if (installType === 'free') config.installProduct.freeInstallation = true;
          else if (installType === 'paid') config.installProduct.freeInstallation = false;
          showInstallServiceable(root, config);
          updateSuccessLine2(root, '*Installation service available at your location');
        },
        function () {
          if (seq !== state.validationSeq) return;
          // Not serviceable — allow purchase but no install add-on
          state.installServiceable = false;
          publishGateState();
          showInstallNotServiceable(root);
          // Remove install hint from headline when install isn't available for this pincode.
          updateSuccessLine1(root, deliveryLine);
          updateSuccessLine2(root, '');
        },
        function () {
          return seq !== state.validationSeq;
        }
      );
    }

    if (checkBtn) checkBtn.addEventListener('click', runCheck);
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); runCheck(); }
      });
      /** Clearing or editing the pincode invalidates ATC until Check is clicked again */
      input.addEventListener('input', function () {
        var raw = normalizedPinFromInput();
        if (raw.length === 0) {
          state.validationSeq++;
          localStorage.removeItem(LS_KEY);
          state.pincodeChecked = false;
          state.pincodeBlocked = false;
          state.consultationRequired = false;
          state.installServiceable = null;
          hideAllMessages(root);
          setAtcButtonsConsultationMode(false);
          quboLog('pincode field emptied — LS cleared, ATC gated');
          publishGateState();
          addOverlays();
          return;
        }
        var ls = localStorage.getItem(LS_KEY);
        if (raw.length !== 6 || raw !== ls) {
          state.validationSeq++;
          state.pincodeChecked = false;
          state.pincodeBlocked = false;
          state.consultationRequired = false;
          state.installServiceable = null;
          hideAllMessages(root);
          setAtcButtonsConsultationMode(false);
          quboLog('pincode changed — must click Check again before ATC');
          publishGateState();
          addOverlays();
        }
      });
    }

    /* ── load delivery sheet on init ── */
    showMsg(root, 'loading');
    setCheckButtonState(checkBtn, false, true, config.buttonLoadingLabel);

    fetchSheetJson(config.sheetUrl)
      .then(function (data) {
        var values = data && data.values;
        if (!values || !Array.isArray(values)) throw new Error('Bad data');
        state.rows = values.slice(1);
        state.sheetError = false;
        hideAllMessages(root);
        setCheckButtonState(checkBtn, true, false);

        // Auto-check if saved pincode (removes overlays on success)
        var saved = localStorage.getItem(LS_KEY);
        if (saved && input) {
          input.value = saved;
          runCheck();
        } else if (config.installationAvailable) {
          quboLog('sheet loaded — no saved pincode; ensuring overlays');
          addOverlays();
        }
      })
      .catch(function () {
        state.sheetError = true;
        state.rows = null;
        state.installServiceable = null;
        hideAllMessages(root);
        showMsg(root, 'error');
        setCheckButtonState(checkBtn, false, false);
        // On sheet error, unblock ATC so user isn't permanently stuck
        unblockAtcButtons(productId);
        setAtcButtonsConsultationMode(false);
        publishGateState();
      });
  }

  /** Used by bundle modal / other flows — safe when script is bundled twice. */
  window.__quboPdcFetchSheetJson = fetchSheetJson;
  window.__quboPdcLookupInstallSheet = lookupInstallSheet;
  window.__quboPdcResolveProductCategory = resolveProductCategory;

  /* ── bootstrap ─────────────────────────────────────────────────── */

  function bootstrapProductDeliveryCheckers() {
    document.querySelectorAll('[data-product-delivery-checker]').forEach(initRoot);
  }

  if (!window.__quboProductDeliveryCheckerDomReady) {
    window.__quboProductDeliveryCheckerDomReady = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrapProductDeliveryCheckers);
    } else {
      bootstrapProductDeliveryCheckers();
    }
  }
})();
